import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTagInput from "components/SuiTagInput";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

import toast from "react-hot-toast";
import api from "services/api";
import moment from "moment";

import { handleUploadFiles, getStyleImages, canResizeImageUrl } from "utils/imageHelper";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import UpStyledLogo from "components/UpStyled/UpStyledLogo";
import ReactPlayer from "react-player";
import Skeleton from "@mui/material/Skeleton";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

/**
 * tutorial modal for user first time login
 */
const MoodboardPageTutorialModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      handleRefresh = () => {},
      handleAfterOk = () => {},
      refreshDelay = 0,
    },
    ref
  ) => {
    const [activeStep, setActiveStep] = useState(0);

    const data = [
      {
        label: "1.Add Image",
        title: "",
        media:
          "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/tutorial-add-image.mov",
      },
      {
        label: "2.Add Link",
        title: "",
        media:
          "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/tutorial-add-link.mov",
      },
      {
        label: "3.Add Color",
        title: "",
        media:
          "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/tutorial-add-color.mp4",
      },
      {
        label: "4.Create Post",
        title: "",
        media:
          "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/_z3GCCWBNlSVn8q7dlE8V/tutorial-create-post.mp4",
      },
      {
        label: "5.Share Moodboard",
        title: "",
        media:
          "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/_z3GCCWBNlSVn8q7dlE8V/tutorial-share.mp4",
      },
    ];

    const handleNext = () => {
      if (activeStep < data.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    };

    const handleBack = () => {
      if (activeStep > 0) {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      }
    };

    return (
      <Dialog
        open={visible}
        onClose={(e, reason) => {
          if (reason != "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogContent>
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <SuiBox>
            <Stepper activeStep={activeStep} alternativeLabel>
              {data.map((item, index) => {
                return (
                  <Step key={index}>
                    <StepLabel sx={{ fontSize: 10 }}>{item?.label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>

            <SuiBox
              width="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
            >
              {data[activeStep]?.title ? (
                <SuiTypography variant="h4" color="dark">
                  {data[activeStep].title}
                </SuiTypography>
              ) : null}
              <SuiBox sx={{ py: 1, px: 15, width: "100%" }}>
                {" "}
                <ReactPlayer
                  controls={true}
                  url={data[activeStep].media}
                  height="auto"
                  width="100%"
                  fallback={
                    <Skeleton animation="wave" height={450} width="100%" variant="rectangular" />
                  }
                  playing={true}
                />
              </SuiBox>
              {/* <SuiTypography variant="h6" sx={{ fontWeight: "regular" }} color="text">
                  {data[activeStep].description}
                </SuiTypography> */}
            </SuiBox>

            <SuiBox display="flex" justifyContent="space-between" alignItems="center" gap={1}>
              <SuiButton
                color="secondary"
                onClick={() => (activeStep == 0 ? handleClose() : handleBack())}
              >
                {activeStep == 0 ? "Cancel" : "Back"}
              </SuiButton>

              <SuiButton
                color="info"
                onClick={() => (activeStep == data.length - 1 ? handleClose() : handleNext())}
              >
                {activeStep == data.length - 1 ? "Done!" : "Next"}
              </SuiButton>
            </SuiBox>
          </SuiBox>
        </DialogContent>
      </Dialog>
    );
  }
);

export default MoodboardPageTutorialModal;
